export enum AmplitudeAutoTrackEvents {
    PageViewed = '[Amplitude] Page Viewed',
}
